import Icon from '../components/Icon.vue'

Icon.register({
  'chess-knight': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M19 272.5c-10.5-4.7-19-17.8-19-29.2v0-137.2-0.1c0-5.5 3.1-13.1 7-16.9l9-9-14.2-28.4c-1-2-1.8-5.4-1.8-7.6v0c0-6.6 5.4-12 12-12h147.9c106 0 191.9 86 191.9 192v192h-319.9v-14.5 0c0-27.3 19.8-59.3 44.2-71.5l57.2-28.7c14.6-7.3 26.5-26.6 26.5-42.9v0-50.3l-22.1 11.1c-5.5 2.7-11.1 9.7-12.6 15.7l-9.2 30.6c-2.5 8.2-10.9 17.3-18.8 20.5l-12.8 5.1c-3.2 1.3-8.5 2.3-11.9 2.3-3.7 0-9.6-1.2-13-2.8zM52 128c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zM368 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-knight.js
// module id = 1180
// module chunks = 0